import { Component, OnInit } from '@angular/core';
import {UserModel, UserService} from '../services/user.service';

@Component({
  selector: 'uoz-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  users: UserModel[] = [];

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.userService.getUsers().subscribe((users) => this.users = users);
  }

}
